import * as Actions from "./constants";
const initialState = {};

export default function subscriptionOrderReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.GET_ALL_SUBSCRIPTION_ORDER:
      return {
        ...state,
      };
    case Actions.GET_ALL_SUBSCRIPTION_ORDER_SUCCESS:
      return {
        ...state,
        subscriptionOrderList: action.payload,
      };
    case Actions.GET_ALL_SUBSCRIPTION_ORDER_ERROR:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}
